import { Inject, Injectable } from '@angular/core';
import { WINDOW } from './WindowService';
import { GA4Ecommerce, GA4EventName } from '../_model/analytics-events';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

  constructor(@Inject(WINDOW) private window: Window) {}

  push(eventName: GA4EventName, ecommerce: GA4Ecommerce | null = null): void {
    try {
      if (ecommerce !== null) {
        this.window['dataLayer'].push({ ecommerce: null });
      }
      const event: Record<string, unknown> = { event: eventName };
      if (ecommerce !== null) {
        event['ecommerce'] = ecommerce;
      }
      this.window['dataLayer'].push(event);
    } catch (e) {
      console.warn('dataLayer push failed:', e);
    }
  }
}
